module.exports = __webpack_public_path__ + "img/raf-offer.eb408768.png";